import { html } from "lit-html";
import { TonerJsEnv } from "../../../models/toner/toner_js_env";
import { TonerArea } from "./toner";

// prettierの自動整形をしたくない場合だけ付与する
// prettier-ignore
export const TonerBody = (model: TonerJsEnv) => html`
${TonerArea(model)}
`;
